
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/hotel",
      function () {
        return require("private-next-pages/visitor/hotel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/hotel"])
      });
    }
  